import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { BANKS, banksUrl } from 'SharedDir/backend/endpoints/banks';
import { BankCreate, BankFull, BankUpdate } from 'SharedDir/declarations/banks';
import { TtpHistory } from 'SharedDir/declarations/ttp-history';

export default class BanksApiClass extends SimpleApi<BankFull, BankCreate, BankUpdate, BankUpdate> {
  constructor() {
    super(banksUrl);
  }

  private readonly endpoints = BANKS;

  public async history(id: number, params: Record<string, string>) {
    const endpoint = this.endpoints.HISTORY(id);

    const { data } = (await http({ ...endpoint, params })) as AxiosResponse<
      TtpHistory.HistoryItem[]
    >;

    return data;
  }
}
